import './main'
import '../scss/app.scss'
